import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Queer (props) {

    const queer = props.queer,
        setQueer = props.setQueer

    useEffect(() => {})

    return (
        <div className="general_field">
            <legend>To what extent do you identify as "<strong>queer</strong>"?</legend>
            <div className="general_options">
                <label>
                    <input 
                        type="radio" 
                        name="queer" 
                        value="5" 
                        checked={queer === "5"}
                        onChange={() => setQueer("5")}
                    />
                        Completely
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="queer" 
                        value="4" 
                        checked={queer === "4"}
                        onChange={() => setQueer("4")}
                    />
                    Strongly
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="queer" 
                        value="3" 
                        checked={queer === "3"}
                        onChange={() => setQueer("3")}
                    />
                    Moderately
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="queer" 
                        value="2"
                        checked={queer === "2"}
                        onChange={() => setQueer("2")}
                    />
                    Slightly
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="queer" 
                        value="1"
                        checked={queer === "1"}
                        onChange={() => setQueer("1")}
                    />
                    Not at all
                </label>
                <label style={{marginTop: '0.3em'}}>
                    <input 
                        type="radio" 
                        name="queer" 
                        value="no_answer"
                        checked={queer === "no_answer"}
                        onChange={() => setQueer("no_answer")}
                        />
                    I prefer not to answer.
                </label>
            </div>
        </div>
    )
}

export default Queer;